import omit from 'lodash/omit';

import { newPermissions } from '@shared/newPermissions';

/**
 * `VIEW_ROSTER_LITE` and `VIEW_ROSTER_PAGE` should be mutually exclusive:
 * a user who can see the full roster should never be routed to the lite roster.
 * If a user holds several positions (e.g. Committee Member + Cubmaster) then the full roster wins, so we drop `VIEW_ROSTER_LITE`
 *
 * Had to use generics since the types were not matching on the return type
 */
export function enforceRosterAccessExclusivity<
  T extends Record<string, boolean>,
>(permissions: T): T {
  if (
    permissions[newPermissions.VIEW_ROSTER_LITE] &&
    permissions[newPermissions.VIEW_ROSTER_PAGE]
  ) {
    return omit(permissions, newPermissions.VIEW_ROSTER_LITE) as T;
  }
  return permissions;
}
